<template>
    <div class="accountsbillingclass">
        <h3><span @click="menu(!desktop)">Account & Billing</span><div></div></h3>
        <div style="padding:20px;">
          <span>Username: </span><span style="font-weight: bold;">{{ user.email }}</span>
          <br><br><br>
          <span>Your Subscription Plan: </span>
          <span v-if="!loading" class="plan">{{ basesub.desc }}<span v-if="istrial">- Free Trial</span></span>
          <span v-else class="plan">Loading...</span>
          <br><br><br>

          <center>
            <div v-if="upgradinginprocess" style="font-weight:bold;">Upgrade in Process...</div>
          </center>
          <div v-if="!istrial && !upgradinginprocess && !upgradestate && !cancelstate && basesub.desc!='No Plan'">
            <span class="buttonupgrade" @click="upgradestate=true">Upgrade Plan</span>
            <span class="buttoncancel" @click="cancelstate=true">Cancel Plan</span>
          </div>
          <div style="border:1px #bbb solid;padding:20px;" v-if="!upgradinginprocess && upgradestate && !cancelstate">
              <center>
                <h3>Choose Upgrade Plan</h3><br>
                <table>
                  <tr>
                    <td v-if="basesub.desc=='Individual Plan'" class="planselection">
                      
                      <table>
                        <tr><td><h4>Team Plan</h4></td></tr>
                      </table>
          
                      <div class="buttonupgrade" @click="Upgrade('team-user-monthly')">Upgrade Now</div>
                    </td>

                    <td v-if="basesub.desc=='Individual Plan' | basesub.desc=='Team Plan'" class="planselection">
              
                      <table>
                        <tr><td><h4>Professional Plan</h4></td></tr>
                      </table>
                      
                      <div class="buttonupgrade" @click="Upgrade('pro-user-monthly')">Upgrade Now</div>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2" style="text-align: center;">
                      <span class="buttoncancel" @click="upgradestate=false">Go Back</span>
                    </td>
                  </tr>
                </table>
                
                <br>
                <div v-if="basesub.desc=='Professional Plan'">
                  You are at the top of the Subscription Plans.  Please contact Sales for further options.
                </div>
              </center>
          </div>


          <div style="border:1px #bbb solid;padding:20px;" v-if="!upgradestate && cancelstate">
            Are you sure that you want to Cancel your Subscription to bOpus?  
            Pressing "YES" will not only cancel your subscription but will also cancel all
            your user subscriptions linked to this account (i.e. Kiosks, Users, Viewers)
            <br><br>
            <center>
              <span class="buttonupgrade" @click="CancelSubscription();">YES</span>
              <span class="buttoncancel" @click="cancelstate=false">NO</span>
            </center>
          </div>
          
          <br><br><hr>
          <div v-if="!istrial">
            <p style="font-weight: bold;color:#777;">Last Five Payments</p>
            <div v-if="!loading">
              <table style="width:100%;border-collapse: true;">
                <tr>
                  <td style="font-weight: bold;font-size: 18px;color:#777;">Payment Date</td>
                  <td style="font-weight: bold;font-size: 18px;color:#777;">Description</td>
                  <td style="font-weight: bold;font-size: 18px;color:#777;">Amount</td>
                  <td style="font-weight: bold;font-size: 18px;color:#777;">Status</td>
                </tr>
                <tr v-for="(item,index) in payments" :key="index">
                  <td style="font-size: 18px;color:#555;">{{ item.created }}</td>
                  <td style="font-size: 18px;color:#555;">{{ item.desc }}</td>
                  <td style="font-size: 18px;color:#555;">{{ item.amount }}</td>
                  <td v-if="item.paid" style="font-size: 18px;padding:6px;">
                    <span class="paid">Paid</span>
                  </td>
                  <td v-else style="font-size: 18px;padding:6px;">
                    <span class="notpaid">Not Paid</span>
                  </td>
                </tr>
              </table>   
            </div>
            <div v-else>Loading...</div>
          </div>
          
               
      </div>
    </div>
</template>

<script setup>
    import { ref, watch } from 'vue';
    import { useStore } from 'vuex';
    const store = useStore();
    let user = ref(store.state.user);
    const basesub = ref([])
    const payments = ref();
    const loading = ref(false);
    const upgradestate = ref(false);
    const cancelstate = ref(false);
    const upgradinginprocess = ref();
    const istrial = ref(true);

    function GoToPaymentPortal()
    {
        alert("This will load an external site.  Once done come back here");
        window.open('https://billing.stripe.com/p/login/test_00gg1Zaewe28e1qeUV', '_blank')
    }

    function Upgrade(pricename) {
      loading.value = true;
      upgradinginprocess.value = true;
      fetch("https://api.bopus.ai/api/payUpgradeTier.php", {
          headers: {'Content-type': 'application/json'},
          method: 'POST',
          body: JSON.stringify({
              "customeremail": user.value.email,
              "subid": basesub.value.subid,
              "subitem": basesub.value.subitem,
              "priceid": pricename
          })
      }).then((res) => res.json()).then((response) => {
          console.log(response);
          loading.value = false;
          upgradestate.value=false
          upgradinginprocess.value = false;
          GetAccountInfo() 
      }).catch((error) => {
          console.log('Looks like there was a problem Upgrading subscriptions: \n', error);
          upgradestate.value=false
      });
    }

    function CancelSubscription() {
      loading.value = true;
      fetch("https://api.bopus.ai/api/payCancelSubscription.php", {
          headers: {'Content-type': 'application/json'},
          method: 'POST',
          body: JSON.stringify({
              "subid": basesub.value.subid,
          })
      }).then((res) => res.json()).then((response) => {
          console.log(response);
          loading.value = false;
          cancelstate.value=false
      }).catch((error) => {
          console.log('Looks like there was a problem Cancelling subscriptions: \n', error);
          loading.value = false;
          cancelstate.value=false
      });
    }

    function GetAccountInfo() {
        loading.value = true;
        fetch("https://api.bopus.ai/api/payGetAccount.php", {
            headers: {'Content-type': 'application/json'},
            method: 'POST',
            body: JSON.stringify({
                "customeremail": user.value.email
            })
        }).then((res) => res.json()).then((response) => {
            console.log("GetAccountInfo response:",response)
            loading.value = false;
            istrial.value = response.istrial;
            if(response.basesub.length>0) {
              basesub.value = response.basesub[0];
              payments.value = response.payments;
            } else {
              basesub.value.desc = "No Plan";
            }
        }).catch((error) => {
            console.log('Looks like there was a problem retrieving subscriptions: \n', error);
            loading.value = false;
        });
    }
    GetAccountInfo();
</script>

<style lang="scss" scoped>
.feature {
  font-size: 18px;
}
.planselection {
  border-radius:10px;
  border: 1px #888 solid;
  padding:30px;
  background-color: rgb(255, 249, 241);
  display: inline-block;
  vertical-align: top;
  margin:20px;
}
.paid {
  padding:6px;
  background-color:#099f45;
  color:white;
  margin:2px;
  border-radius: 8px;
}
.notpaid {
  padding:6px;
  background-color:red;
  color:white;
  margin:2px;
  border-radius: 8px;
}
.plan {
  background-color: #eee;
  padding:8px 10px 8px 10px;
  margin:6px;
  border:1px #333 solid;
}
.buttonupgrade {
  border-radius: 10px;
  color:#099f45;
  background-color:white;
  padding:10px;
  margin:6px;
  border: 1px #099f45 solid; 
  cursor:pointer;
  text-align: center;
}
.buttoncancel {
  border-radius: 10px;
  background-color: #fff;
  border:1px red solid;
  padding:10px;
  margin:6px;
  color:red;
  cursor:pointer;
}
.accountsbillingclass{
    .group_list{
      padding: 20px 20px 0 20px;
      .group_header{
        font-weight: 500;
      }
      >div{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        color: #444;
        border-bottom: 1px solid #bcbcbc;
        >div{
          padding: 8px 0;
          display: flex;
          align-items: center;
        }
        >div:nth-child(1){
          width: 25%;
        }
        >div:nth-child(2){
          width: 63%;
        }
        >div:nth-child(3){
          width: 12%;
          justify-content: center;
          .edit,.delete{
            width: 30px;
            height: 30px;
            background-repeat: no-repeat;
            background-size: 100%;
            background-position: center;
            cursor: pointer;
            flex-shrink: 0;
          }
          .edit{
            background-image: url(../../../public/img/edit.svg);
          }
          .delete{
            margin-left: 15px;
            background-image: url(../../../public/img/delete.svg);
          }
        }
      }
    }
    h3{
      height: 60px;
      line-height: 60px;
      margin: 0px;
      padding: 0 0 0 20px;
      background-color: #f2f2f2;
      position: relative;
      span:last-child{
        height: 30px;
        width: 30px;
        display: inline-block;
        position: absolute;
        top: 50%;
        right: 15px;
        transform: translateY(-50%);
        background-repeat: no-repeat;
        background-size: 24px;
        background-position: center;
        background-image: url(../../../public/img/plus_gray.svg);
        cursor: pointer;
      }
      @media screen and (max-width: 900px){
        span:first-child{
          display: inline-block;
          height: 100%;
          padding-right: 40px;
          background-image: url(../../../public/img/arr_down.svg);
          background-repeat: no-repeat;
          background-position: center right;
        }
      }
    }
  }
</style>